import React from 'react';
import * as Styles from './IconButton.styles';


export default function IconButton({
  icon, onClick, version = 'v1', onlyFillSvg = true, testId = 'icon-button', isDisabled,
}) {
  return (
    <>
      <Styles.Button
        onClick={onClick}
        data-testid={testId}
        $version={version}
        $onlyFillSvg={onlyFillSvg}
        disabled={isDisabled}
      >
        {icon}
      </Styles.Button>
    </>
  );
}
